export const activityNotFound = "/images/notFound/ActivityNotFound.jpg";
export const defaultNotFound = "/images/notFound/ActivityNotFound.jpg";
export const weekDefaultNotFound = "/images/notFound/ActivityNotFound.jpg";
export const RoomDefaultNotFound = "/images/notFound/GenericRoom.png";
